import React from "react";
import "../LegalDoc/legal.scss";
import Tan from "../../assets/images/Tan.png";
import detail from "../../assets/images/detail.jpeg";
import details from "../../assets/images/details.jpeg";
import GST from "../../assets/pdf/GSTcertificate.pdf";
import Pan from "../../assets/pdf/Pan.pdf";
import SPICE from "../../assets/pdf/SPICE.pdf";
import TAN from "../../assets/pdf/Tan.pdf";

const Legal = () => {
    return (
        <div className="container-fluid login" id="about" style={{ height: "unset", padding: "20px" }}>
            <h1 style={{ marginTop: "20px", textAlign: "center" }}>COMPANY DOCUMENTS AND CERTIFICATES</h1>

            <div className="documents-grid" style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                gap: "20px",
                marginTop: "30px"
            }}>
                <div className="document-card" style={{
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    padding: "20px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    backgroundColor: "#fff"
                }}>
                    <h3 style={{ color: "#333", marginBottom: "15px" }}>Company Documents</h3>
                    <div style={{
                        backgroundColor: "#f9f9f9",
                        padding: "15px",
                        borderRadius: "5px",
                        marginBottom: "15px"
                    }}>
                        View our company certificates and documents below.
                    </div>
                    
                    {/* Images in single row with 3 columns */}
                    <div style={{ 
                        display: "grid", 
                        gridTemplateColumns: "repeat(3, 1fr)", 
                        gap: "15px", 
                        marginBottom: "20px" 
                    }}>
                        {/* <img src={Tan} alt="TAN Certificate" style={{ width: "100%", borderRadius: "5px", height: "100%", objectFit: "cover" }} /> */}
                        <img src={detail} alt="Company Detail" style={{ width: "100%", borderRadius: "5px", height: "100%", objectFit: "cover" }} />
                        <img src={details} alt="Company Details" style={{ width: "100%", borderRadius: "5px", height: "100%", objectFit: "cover" }} />
                    </div>
                    
                    {/* PDF Links */}
                    <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                        <a href={GST} target="_blank" rel="noopener noreferrer" 
                           style={{
                               display: "block",
                               padding: "10px",
                               backgroundColor: "#007bff",
                               color: "white",
                               textAlign: "center",
                               borderRadius: "5px",
                               textDecoration: "none",
                               transition: "background-color 0.3s ease"
                           }}
                           onMouseOver={(e) => e.target.style.backgroundColor = "#0056b3"}
                           onMouseOut={(e) => e.target.style.backgroundColor = "#007bff"}>
                            View GST Certificate (PDF)
                        </a>
                        <a href={SPICE} target="_blank" rel="noopener noreferrer" 
                           style={{
                               display: "block",
                               padding: "10px",
                               backgroundColor: "#007bff",
                               color: "white",
                               textAlign: "center",
                               borderRadius: "5px",
                               textDecoration: "none",
                               transition: "background-color 0.3s ease"
                           }}
                           onMouseOver={(e) => e.target.style.backgroundColor = "#0056b3"}
                           onMouseOut={(e) => e.target.style.backgroundColor = "#007bff"}>
                            View SPICE Certificate (PDF)
                        </a>
                        <a href={Pan} target="_blank" rel="noopener noreferrer" 
                           style={{
                               display: "block",
                               padding: "10px",
                               backgroundColor: "#007bff",
                               color: "white",
                               textAlign: "center",
                               borderRadius: "5px",
                               textDecoration: "none",
                               transition: "background-color 0.3s ease"
                           }}
                           onMouseOver={(e) => e.target.style.backgroundColor = "#0056b3"}
                           onMouseOut={(e) => e.target.style.backgroundColor = "#007bff"}>
                            View PAN Certificate (PDF)
                        </a>
                        <a href={TAN} target="_blank" rel="noopener noreferrer" 
                           style={{
                               display: "block",
                               padding: "10px",
                               backgroundColor: "#007bff",
                               color: "white",
                               textAlign: "center",
                               borderRadius: "5px",
                               textDecoration: "none",
                               transition: "background-color 0.3s ease"
                           }}
                           onMouseOver={(e) => e.target.style.backgroundColor = "#0056b3"}
                           onMouseOut={(e) => e.target.style.backgroundColor = "#007bff"}>
                            View TAN Certificate (PDF)
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Legal;